// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__3ttTE","label":"Completed_label__3irdE"};